/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { StopBotOptions, StopBotResponses } from '../types/StopBot'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Stop a bot
 * {@link /v1/bots/:bot_id/stop}
 */
export function stopBot<ThrowOnError extends boolean = true>(
  options: Options<StopBotOptions, ThrowOnError>,
): Unwrappable<RequestResult<StopBotResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/bots/{bot_id}/stop',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<StopBotResponses, ThrowOnError>>,
  )
}
